import { Typography } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";
import animationData from "assets/images/info.json";


const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const InfoIcon = ({width, height}) => {
  return (
    <div>
      <Lottie options={defaultOptions} height={height || '100px'} width={width || '100px'} />
    </div>
  );
};

export default InfoIcon;
